import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import WalkerRecruitmentLandingPage from "./pages/WalkerRecruitmentLandingPage";
import WalkersSearchPage from "./pages/WalkersSearchPage";
import WalkerDetailPage from "./pages/WalkerDetailPage";
import JoinWalkerPage from "./pages/JoinWalkerPage";
import ConversationReplyPage from "./pages/ConversationReplyPage";
import OwnerConversationAccessPage from "./pages/OwnerConversationAccessPage";
import OwnerBookingsPage from "./pages/OwnerBookingsPage";
import WalkerAccessRequestPage from "./pages/WalkerAccessRequestPage";
import WalkerMagicConsumePage from "./pages/WalkerMagicConsumePage";
import WalkerDashboardPage from "./pages/WalkerDashboardPage";
import WalkerMessagesPage from "./pages/WalkerMessagesPage";
import WalkerBookingsPage from "./pages/WalkerBookingsPage";
import WalkerStripeRefreshPage from "./pages/WalkerStripeRefreshPage";
import AdminConversationsPage from "./pages/AdminConversationsPage";
import { WalkerAuthProvider } from "./context/WalkerAuthContext";

function App() {
  return (
    <WalkerAuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<WalkerRecruitmentLandingPage />} />
          <Route path="/normal-home" element={<LandingPage />} />

          <Route path="/walkers" element={<WalkersSearchPage />} />
          <Route path="/walkers/:slug" element={<WalkerDetailPage />} />
          <Route path="/join-walker" element={<JoinWalkerPage />} />

          <Route path="/reply/:token" element={<ConversationReplyPage />} />
          <Route
            path="/conversation/:token"
            element={<ConversationReplyPage />}
          />
          <Route path="/reply-access" element={<OwnerConversationAccessPage />} />
          <Route path="/owner/bookings/:token" element={<OwnerBookingsPage />} />

          <Route
            path="/walker"
            element={<Navigate to="/walker/dashboard" replace />}
          />
          <Route path="/walker/access" element={<WalkerAccessRequestPage />} />
          <Route
            path="/walker/magic/:token"
            element={<WalkerMagicConsumePage />}
          />
          <Route path="/walker/dashboard" element={<WalkerDashboardPage />} />
          <Route path="/walker/messages" element={<WalkerMessagesPage />} />
          <Route path="/walker/bookings" element={<WalkerBookingsPage />} />
          <Route
            path="/walker/stripe/refresh"
            element={<WalkerStripeRefreshPage />}
          />

          <Route
            path="/admin/conversations"
            element={<AdminConversationsPage />}
          />
        </Routes>
      </BrowserRouter>
    </WalkerAuthProvider>
  );
}

export default App;